import { ChevronLeftIcon, ChevronRightIcon } from "./Icons.tsx";

const ARROW =
  "flex size-9 items-center justify-center rounded-lg border border-line bg-paper text-ink-2 hover:bg-surface disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:bg-paper";

/**
 * The two arrows that move a calendar view back and forward by one `unit`: a day on the Calendar's
 * Day view, a week on its Week view, a month on a monthly report. The names are "Previous day",
 * "Next week" and so on. `nextDisabled` stops the view at a limit: a report has no month after this one.
 */
export function StepArrows({
  unit,
  onPrevious,
  onNext,
  nextDisabled = false,
}: {
  unit: string;
  onPrevious: () => void;
  onNext: () => void;
  nextDisabled?: boolean;
}) {
  return (
    <div className="flex items-center gap-1">
      <button type="button" aria-label={`Previous ${unit}`} onClick={onPrevious} className={ARROW}>
        <ChevronLeftIcon size={17} />
      </button>
      <button type="button" aria-label={`Next ${unit}`} onClick={onNext} disabled={nextDisabled} className={ARROW}>
        <ChevronRightIcon size={17} />
      </button>
    </div>
  );
}
